import { http, HttpResponse, PathParams } from "msw";

import { ListSecretsResponse } from "@protos/secrets/v1/secrets";

import { generateSecretData } from "./data";

// randomly generated data for fullstory
export const secretsHandlersGenerated = [
  http.get<PathParams, ListSecretsResponse>(
    "/api/secrets/deployments/:deploymentId/findings",
    ({ request }) => {
      const url = new URL(request.url);
      const cursor = url.searchParams.get("cursor");
      const limit = url.searchParams.get("limit");
      const intLimit = limit ? parseInt(limit) : 10;
      let newCursor: number;
      if (cursor) {
        const curr = parseInt(cursor);
        newCursor = curr + 1;
      } else {
        newCursor = 1;
      }

      const data = generateSecretData(intLimit);
      const resp: ListSecretsResponse = {
        findings: data,
        cursor: newCursor.toString(),
      };

      return HttpResponse.json(resp);
    }
  ),
];

export const secretsHandlersStatic = [
  http.get("*/api/secrets/deployments/:deploymentId/findings/count", () =>
    HttpResponse.json({}, { status: 200 })
  ),
];
